import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { LIVESTOCK_SUMMARY_INDEX } from '../../../router/routes';
import { formatDateValue, route } from '../../../services/utils';
import { useService } from '../../../services/services';
import { LinkComponent } from '../../../components/form/elements/link';
import { faLongArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import css from './summary-view.module.css';
import { useTranslation } from 'react-i18next';
import CowProductionSummary from './components/summary/cow-production-summary';
import HerdSizeSummary from './components/summary/herd-size-summary';
import AnnualYieldSummary from './components/summary/annual-yield-summary';
import { SummaryInfo } from '../../../interfaces/livestock-summary';

export enum TabKey {
  DAIRY = 'dairy',
}

export default function ViewSummary() {
  const { livestockSummaryService } = useService();
  const { t } = useTranslation();
  const { farmId, id } = useParams<{ farmId: string; id: string }>();

  const SummaryType = {
    HERD_SIZE: t('pages.livestock.summary.header.summary_cow'),
    DAYS_IN_MILK: t('pages.livestock.summary.header.summary_day'),
    MILK_PER_COW_DAY: t('pages.livestock.summary.header.summary_produce_day'),
    MILK_YIELD_ANNUAL: t('pages.livestock.summary.header.summary_produce_year'),
  };

  const [title, setTitle] = useState('');
  const [date, setDate] = useState('');
  const [summaryData, setSummaryData] = useState<SummaryInfo>({
    produce: [],
    herdCow: [],
    oldCow: [],
    firstMilk: [],
    avgYear: null,
    cows: [],
    avgDays: null,
    cowsThisYear: null,
    cowsPrevYear: null
  });

  const [loading, isLoading] = useState(true);

  useEffect(() => {
    livestockSummaryService
      .summaryType(farmId, id)
      .subscribe((response: any) => {
        setTitle(response.summary);
        setDate(response.current_date);
      });
  }, [livestockSummaryService, farmId, id]);

  useEffect(() => {
    livestockSummaryService.summaryInfo(farmId, date, title).subscribe(
      (response: SummaryInfo) => {
        setSummaryData(response);
        isLoading(false);
      })
  }, [livestockSummaryService, farmId, date, title]);

  return (
    <div className={css['field-info']}>
      <div className={css['header']}>
        <LinkComponent
          label="back"
          icon={faLongArrowLeft}
          linkTo={route(LIVESTOCK_SUMMARY_INDEX, {
            farmId: farmId,
            tab: TabKey.DAIRY,
          })}
        />
        <h2>{title ? title : ''}</h2>
      </div>

      <div className={css['top-bar']}>
        <div>
          <span>{t('pages.livestock.summary.section.control_date')}</span>
          <span className={css['strong']}>: {date && formatDateValue(date)} </span>
        </div>
      </div>

      {(title === SummaryType.DAYS_IN_MILK ||
        title === SummaryType.MILK_PER_COW_DAY) && (
          <CowProductionSummary summaryData={summaryData} title={title} />
        )}

      {title === SummaryType.HERD_SIZE && (
        <HerdSizeSummary summaryData={summaryData} title={title} />
      )}

      {title === SummaryType.MILK_YIELD_ANNUAL && (
        <AnnualYieldSummary summaryData={summaryData} title={title} loading={loading} />
      )}
    </div>
  );
}